import React, { Component } from 'react'
import _ from 'lodash'
import axios from 'axios'
import { Helmet } from 'react-helmet'
import SportComponent from './SportComponent'
import { isLive } from '~/tools/mll/helpers'
import config from './config.js'
import './index.css'

class GameDetail extends Component {
	state = {
		items: this.props.data && this.props.data.contentData[0].gist,
	}

	componentDidMount = () => {
		if (this.state.items) {
			const type = this.state.items.contentType;
			const env = config[type];
			const time = this.state.items[env.schedule][0][env.time];
			const faceoffTime = time * 1000;
			const self = this

			this.interval = setInterval(
				function getEvent() {
					axios.get(`${env.api}/${self.state.items.dataId}/${Date.now()}`)
					.then(res => {
						self.setState({
							data: res.data,
							env: env,
							faceoffTime: faceoffTime,
						})
					})
					.catch(err => {
						console.log(err)
					})
					return getEvent
				}.call(self),
				(this.props.data.metadataMap.apiCallInterval || 120) * 1000
			)
		}
	}

	componentDidUpdate = () => {
		const data = this.state.data
		if (data && !isLive(this.state.items.contentType, data)) {
			clearInterval(this.interval)
		}
	}

	get helmet() {
		const { gist = {}, seo = {} } = this.props.data.contentData[0]

		return (
			<Helmet>
				<title>{`${seo.title || gist.title} | ${window.settings.site}`}</title>
				<meta name="description" content={seo.description || gist.description} />
				{seo.keywords && <meta name="keywords" content={seo.keywords.join(',')} />}
				<meta property="og:type" content="article" />
				<meta property="og:title" content={seo.title || gist.title} />
				<meta property="og:description" content={seo.description || gist.description} />
				<meta
					property="og:image"
					content={gist.landscapeImageUrl || _.get(window.settings, 'images.placeholderCover')}
				/>
			</Helmet>
		)
	}

	render() {
		return (
			<div>
				{this.helmet}
				{this.state.data && (
					<SportComponent
						api={this.state.data}
						page={this.state.items}
						env={this.state.env}
						faceoffTime={this.state.faceoffTime}
					/>
				)}
			</div>
		)
	}
}

export default GameDetail
